export const MOVIE_LANDING_PAGE_RAILS = {
  LATEST_LANGUAGE_MOVIES: 'Latest Language Movies',
  TRENDING_LANGUAGE_MOVIES: 'Trending Language Movies',
  PREMIUM_LANGUAGE_MOVIES: 'Premium Language Movies',
  POPULAR_LANGUAGE_MOVIES: 'Popular Language Movies',
  ZEE5_ORIGINAL: 'collection_title_zee5_originals',
  // CELEBRITIES: "celebrities",
  MOVIES_GENRES: 'Genres Movies',
  MOVIES_LANGUAGES: 'Languages Movies',
  MOVIES_BROWSE_BY_LANGUAGE: 'Browse by language',
  MOVIES_BROWSE_BY_GENRE: 'Browse by genre',
  ALL_MOVIES: 'All Movies',
  BOLLYWOOD_MOVIES: 'Bollywood Movies',
  LATEST_GENRE_MOVIES: 'Latest Genre Movies',
  TRENDING_GENRE_MOVIES: 'Trending Genre Movies',
  PREMIUM_GENRE_MOVIES: 'Premium Genre Movies',
  POPULAR_GENRE_MOVIES: 'Popular Genre Movies',
  LATEST_CELEB_MOVIES: 'Latest Celeb Movies',
  POPULAR_CELEB_MOVIES: 'Popular Celeb Movies',
  ALL_CELEB_MOVIES: 'All Celeb Movies',
  LATEST_ZEE5_EXCLUSIVE_MOVIES: 'Latest Zee5 Exclusive Movies',
  LANGUAGE_ZEE5_EXCLUSIVE_MOVIES: 'Languages ZEE5 Exclusive Movies',
  LATEST_ZEE5_ORIGINAL_MOVIES: 'Latest ZEE5 Original Movies',
  LANGUAGE_ZEE5_ORIGINAL_MOVIES: 'Languages ZEE5 Original Movies',
  ALL_ZEE5_ORIGINAL_MOVIES: 'All ZEE5 Original Movies',
  TRENDING_PREMIUM_MOVIES: 'Trending Premium Movies',
  POPULAR_PREMIUM_MOVIES: 'Popular Premium Movies',
  ZEE5_ORIGINAL_PREMIUM_MOVIES: 'Originals Premium Movies',
  LANGUAGE_PREMIUM_MOVIES: 'Languages Premium Movies',
  ALL_PREMIUM_MOVIES: 'All Premium Movies',
  TRENDING_FREE_MOVIES: 'Trending Free Movies',
  POPULAR_FREE_MOVIES: 'Popular Free Movies',
  ZEE5_ORIGINAL_FREE_MOVIES: 'Originals Free Movies',
  LANGUAGE_FREE_MOVIES: 'Languages Free Movies',
  ALL_FREE_MOVIES: 'All Free Movies',
  LATEST_BOLLYWOOD_MOVIES: 'Latest Bollywood Movies',
  TRENDING_BOLLYWOOD_MOVIES: 'Trending Bollywood Movies',
  POPULAR_BOLLYWOOD_MOVIES: 'Popular Bollywood Movies',
  ALL_BOLLYWOOD_MOVIES: 'All Bollywood Movies',
  LATEST_HOLLYWOOD_MOVIES: 'Latest Hollywood Movies',
  TRENDING_HOLLYWOOD_MOVIES: 'Trending Hollywood Movies',
  POPULAR_HOLLYWOOD_MOVIES: 'Popular Hollywood Movies',
  ALL_HOLLYWOOD_MOVIES: 'All Hollywood Movies',
  LATEST_SOUTH_INDIAN_MOVIES: 'Latest South Indian Movies',
  TRENDING_SOUTH_INDIAN_MOVIES: 'Trending South Indian Movies',
  POPULAR_SOUTH_INDIAN_MOVIES: 'Popular South Indian Movies',
  TELUGU_MOVIES: 'Telugu Movies',
  TAMIL_MOVIES: 'Tamil Movies',
  KANNADA_MOVIES: 'Kannada Movies',
  MALAYALAM_MOVIES: 'Malayalam Movies',
  ALL_SOUTH_INDIAN_MOVIES: 'All South Indian Movies',
  MOVIESUBLANDINGPAGE: 'movieSubLandingPageContainer',
  ALLCELEB: 'allCeleb'
};
